module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"Oops. Something went wrong. Please restart."},"es":{"message":"Dios mío, algo salió mal. Por favor reinicie."},"sw":{"message":"Ah mpenzi, kuna kitu kilienda vibaya. Tafadhali anzisha upya."}}')
  delete Component.options._Ctor
}
